import React from 'react'
// import { routes } from './index'\

import { Index } from '../views/Index'
import { Profile } from '../views/Profile'
import { LotDetail } from '../views/Lot'
import { User } from '../views/User'
import { TokenDetail } from '../views/TokenOriginal'
import { Search } from '../views/Search'

import { AuthMiddleware } from './middlewares/Auth'

import { Switch, Route } from 'react-router-dom'
import { PremiumPage } from '../views/Premium'
import { Error404 } from '../views/404'
import HomePage from '../components/HomePage'
import About from '../components/About'
import Ambassador from '../components/Ambassador'
import Contact from '../components/Contact'
import Roadmap from '../components/Roadmap'
import Team from '../components/Team'
import { Header } from '../components/Header'
import Audit from '../components/Audit'

export const Router = () => {
    return (
        <Switch>
            <Route path="/about" exact>
                <About></About>
            </Route>
            <Route path="/ambassador" exact>
                <Ambassador />
            </Route>
            <Route path="/contact" exact>
                <Contact />
            </Route>
            <Route path="/roadmap" exact>
                <Roadmap />
            </Route>
            <Route path="/team" exact>
                <Team />
            </Route>
            <Route path="/audit" exact>
                <Audit />
            </Route>
            <Route path="/dashboard" exact>
                <Header />
                <Index></Index>
            </Route>
            <Route path="/profile" exact>
                <Header />
                <AuthMiddleware>
                    <Profile></Profile>
                </AuthMiddleware>
            </Route>
            <Route path="/lot/:id">
                <Header />
                <LotDetail></LotDetail>
            </Route>
            <Route path="/original-token/:id">
                <Header />
                <TokenDetail></TokenDetail>
            </Route>
            <Route path="/user/:id">
                <Header />
                <User></User>
            </Route>
            <Route path="/search/">
                <Header />
                <Search></Search>
            </Route>
            <Route path="/premium/:id">
                <Header />
                <AuthMiddleware>
                    <PremiumPage></PremiumPage>
                </AuthMiddleware>
            </Route>
            <Route path="/">
                <HomePage></HomePage>
            </Route>
            <Route path="/*">
                <Error404></Error404>
            </Route>
        </Switch>
    )
}
